import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'r1-root',
    template: ` <router-outlet /> `,
    imports: [RouterOutlet],
})
export class AppComponent {}
